export default {
    baseUrl: $('body').attr('data-base-url'),
    requestVerificationToken: $('#token-form input[name="__RequestVerificationToken"]').val(),
    businessName: null,
    contactPerson: null,
    email: null,
    permitYear: '',
    permitYearsLoading: false,
    permitYears: null,
    permitValidated: false,
    permitNumber: null,
    facilityUsages: [],
    activities: null,
    activitiesLoading: false,
    areas: null,
    areasLoading: false,
    facilities: null,
    facilitiesLoading: false,
    zeroFacilityUsagesReport: false,
    isZeroFacilityUsagesReportSubmission: false,
    persistentStorageChecked: false,
    permitNumberServerValidationError: false,
    permitNumberServerValidationErrorMessage: null,
    shouldAutosave: true,
    performingInitialLoad: true,
    pendingAsyncRequest: false,
    clientDaysHelpText: 'Commercial operators who offer multiple recereational services in any given day (such as guided watercraft tours and overnight camping), are required to pay only one per client fee per day, based upon the highest per client fee for the particular activities provided. Record these individuals only once/day in this report.'
};